import {useEffect, useState} from 'react';
import fetchUserSavedPartners from '../../../../services/fetchUserSavedPartners';
import fetchPartners from "../../../../services/fetchPartners";
import fetchPartnerUserSavedCounts from "../../../../services/fetchPartnerUserSavedCounts";
import appConstants from "../../../../constants";

export default function useUserSavedPartners(user, refetch, setRefetch) {
  const [isUserSavedPartnersFetchingInProgress, setIsUserSavedPartnersFetchingInProgress] = useState(false);
  const [userSavedPartnersFetchingError, setUserSavedPartnersFetchingError] = useState(null);

  const [userSavedPartnerSiteIds, setUserSavedPartnerSiteIds] = useState('');
  const [userSavedPartners, setUserSavedPartners] = useState([]);
  //const [userSavedPartnerCount, setUserSavedPartnerCount] = useState(0);

  function getUserSavedPartnerFavTrackId(userSavedPartnerIds, partnerSiteId) {
    const record = userSavedPartnerIds.filter(userSavedPartnerId => userSavedPartnerId[appConstants.KEY_SITE_ID] === `${partnerSiteId}`);
    return !!record.length ? parseInt(record[0].FAV_PARTNER_ID) : '-1';
  }

  function getPartnerUserSavedCount(partnerUserSavedCounts, partnerSiteId) {
    const record = partnerUserSavedCounts.filter(partnerUserSavedCount => partnerUserSavedCount[appConstants.KEY_SITEID] === `${partnerSiteId}`);
    return !!record.length ? parseInt(record[0].partnerCount):0;
  }
  useEffect(
    () => {
      async function getUserSavedPartners(ccoId) {

        const userSavedPartnerIds = await fetchUserSavedPartners(ccoId);
        if (!userSavedPartnerIds.hasError) {

          if(!!userSavedPartnerIds.savedPartnerSiteIds && !!userSavedPartnerIds.savedPartnerSiteIds.length) {

            const savedPartners = await fetchPartners(userSavedPartnerIds.savedPartnerSiteIds);
            if (!savedPartners.hasError) {

              const partnerUserSavedCounts = await fetchPartnerUserSavedCounts(savedPartners.fetchedPartners.map(foundPartner => foundPartner[appConstants.KEY_SITE_ID_LOWERCASE]).join(','));
              if (!partnerUserSavedCounts.hasError && !!savedPartners.fetchedPartners.length) {
                savedPartners.fetchedPartners =
                  savedPartners.fetchedPartners.map(
                    foundPartner => {
                      return {
                        ...foundPartner,
                        savedCount: getPartnerUserSavedCount(partnerUserSavedCounts.partnerUserSavedCounts, foundPartner[appConstants.KEY_SITE_ID_LOWERCASE]),
                        favTrackId: getUserSavedPartnerFavTrackId(userSavedPartnerIds.originalData, foundPartner[appConstants.KEY_SITE_ID_LOWERCASE])
                      }
                    }
                  );
              }
              setUserSavedPartnersFetchingError(null);
              setUserSavedPartnerSiteIds(userSavedPartnerIds.savedPartnerSiteIds);
              setUserSavedPartners(previousValue => savedPartners.fetchedPartners);
              //setUserSavedPartnerCount(savedPartners.fetchedPartnerCount);
            }
          }
          else {
            setUserSavedPartnersFetchingError(null);
            setUserSavedPartnerSiteIds('');
            setUserSavedPartners(previousValue => []);
            //setUserSavedPartnerCount(0);
          }
        }
        else {
          setUserSavedPartnersFetchingError(userSavedPartnerIds.errorMessage);
          setUserSavedPartnerSiteIds('');
          setUserSavedPartners(previousValue => []);
          //setUserSavedPartnerCount(0);
        }
        setIsUserSavedPartnersFetchingInProgress(false);
      }
      const ccoId = user.getId();
      if ((ccoId.toLowerCase() !== 'guest') && refetch) {
        setIsUserSavedPartnersFetchingInProgress(true);
        getUserSavedPartners(ccoId);
        setRefetch(false);
      }
    },

    [user, refetch, setRefetch]
  );

  return {
    isUserSavedPartnersFetchingInProgress,
    userSavedPartnersFetchingError,
    userSavedPartnerSiteIds,
    userSavedPartners//,
    //userSavedPartnerCount
  }

}


